import { profile } from "@shared/api/services"
import { useMutation, useQueryClient } from "@tanstack/react-query"

export const useOnboardingPassed = () => {
	const queryClient = useQueryClient()

	const mutation = useMutation({
		mutationFn: (data) => profile.onboardingPassed(data),
    onSuccess: () => {
      queryClient.invalidateQueries(['profile'])
    },
  })

	return mutation
}